import React, { useEffect, useState } from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/banner.jpg";
import "../../assets/styles/contact.css";
import { axiosInstance } from "../config";
import { notification } from "antd";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";
import Loader from "../../components/common/Loader";

const Index = () => {
  useEffect(() => window.scrollTo(0, 0), [])
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [isLoading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobile", mobile);
    formData.append("message", message);
    formData.append("company_name", companyName);
    try {
      const res = await axiosInstance.post("https://www.rolioxalloys.in/backend/api/contact", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      if (res.data.message == "Message Succesfully sent...") {
        notification.open({
          message: "Message Received Successfully ",
          description: (
            <div style={{ color: "#000", zIndex: 999 }}>
              Your message has been sent! 🎉 Thank you for reaching out to us.
              We’re excited to connect and will get back to you shortly. Stay
              tuned!
            </div>
          ),
          showProgress: true,
          className: "custom-notification",
        });
        setName("");
        setEmail("");
        setMessage("");
        setMobile("");
        setCompanyName("");
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      <Helmet>
        <title>Contact Us - Roliox Alloys</title>
      </Helmet>
      {isLoading && <Loader />}
      <Navbar inner={true} />
      <BannerSection
        Banner={ContactBanner}
        title={"Contact us"}
        subtitle={"Let success motivate you."}
      />

      <div className="site-content">
        <div className="contact-info-area ptb-80">
          <div className="container">
            <div className="row justify-content-center">
              <div
                className={`col-lg-4 col-md-6 col-sm-6 contact-details service-animate ${inView1 ? "visible" : ""
                  }`}
                ref={ref1}
              >
                <div className="contact-info-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <h3>Mail Here</h3>
                  <p>
                    <a href="mailto:sales@rolioxalloys.in">
                      sales@rolioxalloys.in
                    </a>
                  </p>
                </div>
              </div>
              <div
                className={`col-lg-4 col-md-6 col-sm-6 contact-details service-animate ${inView2 ? "visible" : ""
                  }`}
                ref={ref2}
              >
                <div className="contact-info-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </div>
                  <h3>Visit Here</h3>
                  <p>27, Shivadhin Industrial Park Amba Hotel, At-Chandial, Ahmedabad
                    382433</p>
                </div>
              </div>
              <div
                className={`col-lg-4 col-md-6 col-sm-6 contact-details phone-num service-animate ${inView3 ? "visible" : ""
                  }`}
                ref={ref3}
              >
                <div className="contact-info-box">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </div>
                  <h3>Call Here</h3>
                  <p>
                    <a href="tel:+91-9904401093">+91 99044 01093</a>
                    <span className="icon-phone">/</span>
                    <a href="tel:+91-7069352196">+91 70693 52196</a>
                    {/* <span className="icon-phone">/</span> */}
                    {/* <a href="tel:+91-7383477077">+91 73834 77077</a> */}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-area ptb-80">
          <div className="container">
            <div className="section-title">
              <h2 className="pb-2">Get In Touch With Us</h2>
              <p>Anything On your Mind. We’ll Be Glad To Assist You!</p>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.6546786528024!2d72.818049!3d22.9997225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e7b0018d9bb49%3A0xadaf982ece9549a0!2sROLIOX%20ALLOYS!5e0!3m2!1sen!2sin!4v1774626467927!5m2!1sen!2sin"
                  width="100%"
                  height="350"
                  loading="lazy"
                ></iframe>
              </div>
              <div className="col-lg-6 col-md-12  form-enquiry">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          className="form-control"
                          aria-label="Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="company_name"
                          placeholder="Company Name"
                          className="form-control"
                          required=""
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="email"
                          placeholder="Email Address"
                          className="form-control"
                          aria-label="Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="number"
                          id="phone"
                          placeholder="Phone Number"
                          className="form-control"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          required
                        />
                      </div>
                    </div>
                    {/* <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <select
                          className="form-control"
                          value={service}
                          onChange={(e) => setService(e.target.value)}
                        >
                          <option value="">Select the Service</option>
                          <option value="Software Development">
                            Software Development
                          </option>
                          <option value="Mobile App Development">
                            Mobile App Development
                          </option>
                          <option value="Hire a resource">
                            Hire a resource
                          </option>
                          <option value="Digital marketing">
                            Digital marketing
                          </option>
                          <option value="Maintenance">Maintenance</option>
                          <option value="Graphics Design">
                            Graphics Design
                          </option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div> */}
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <textarea
                          name="text"
                          cols="30"
                          rows="5"
                          placeholder="Share your Requirement"
                          className="form-control"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                      <button type="submit" className="btn btn-primary submit-btn">
                        Send Message
                        {isLoading && (
                          <span
                            className="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
